import React from 'react';

function Contact() {
  return (
    <div className="App-section">
      <h2>Contact</h2>
      
      <div className="contact-intro">
        <p>I'm always open to discussing new opportunities, collaborations, or just having a chat about technology and innovation. Feel free to reach out!</p>
      </div>

      <div className="contact-cards-container">
        <div className="contact-card">
          <h3><i className="fas fa-info-circle"></i> Contact Information</h3>
          <div className="contact-info-item">
            <i className="fas fa-user"></i>
            <div>
              <strong>Name</strong>
              <p>Passawit Suriyodorn</p>
            </div>
          </div>
          <div className="contact-info-item">
            <i className="fas fa-briefcase"></i>
            <div>
              <strong>Title</strong>
              <p>IT/ML Solutions Engineer</p>
            </div>
          </div>
          <div className="contact-info-item">
            <i className="fas fa-map-marker-alt"></i>
            <div>
              <strong>Locations</strong>
              <p>Bangkok, Thailand</p>
              <p>Hannover, Germany</p>
            </div>
          </div>
          <div className="contact-info-item">
            <i className="fas fa-clock"></i>
            <div>
              <strong>Timezone</strong>
              <p>GMT+7 (Bangkok) / GMT+1 (Hannover)</p>
            </div>
          </div>
          <div className="contact-info-item">
            <i className="fas fa-reply"></i>
            <div>
              <strong>Response Time</strong>
              <p>Usually within 24-48 hours</p>
            </div>
          </div>
        </div>

        <div className="contact-card">
          <h3><i className="fas fa-paper-plane"></i> Preferred Contact</h3>
          <p className="preferred-method">Email is the best way to reach me for professional inquiries.</p>
          <div className="contact-methods">
            <div className="contact-method-item">
              <i className="fas fa-envelope"></i>
              <div>
                <strong>Email</strong>
                <a href="mailto:passawit.suriyodorn@gmail.com">passawit.suriyodorn@gmail.com</a>
              </div>
            </div>
            <div className="contact-method-item">
              <i className="fas fa-phone"></i>
              <div>
                <strong>Phone</strong>
                <a href="tel:+491734073617">+49 173 407 3617</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="social-section">
        <h3><i className="fas fa-share-alt"></i> Connect on Social Media</h3>
        <div className="contact-container">
          <a href="mailto:passawit.suriyodorn@gmail.com" className="contact-button">
            <i className="fas fa-envelope"></i> Email
          </a>
          <a href="tel:+491734073617" className="contact-button">
            <i className="fas fa-phone"></i> Phone
          </a>
          <a href="https://www.linkedin.com/in/passawit-suriyodorn/" target="_blank" rel="noopener noreferrer" className="contact-button">
            <i className="fab fa-linkedin"></i> LinkedIn
          </a>
          <a href="https://github.com/manofculturett" target="_blank" rel="noopener noreferrer" className="contact-button">
            <i className="fab fa-github"></i> GitHub
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;